import {
  DeleteOutline as DeleteOutlinedIcon,
  SaveAlt,
} from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import { Button, Tooltip } from '@mui/material';
import dayjs from 'dayjs';
import { useRef, useState } from 'react';
import { CSVLink } from 'react-csv';
import { ASSEMBLY_PUBLICATION_HEADERS } from 'src/constants';
import { useParamQuery } from 'src/hooks';
import { lang } from 'src/utils';

import { PUBLICATION_STATUS } from '../../AssemblyPublicationPage.interface';
import { useExportAllAssemblies } from '../../hooks/AssemblyExportList.hook';
import { AssemblyPublicationFooterProps } from './AssemblyPublicationFooter.interface';
import {
  FooterActions,
  FooterContainer,
} from './AssemblyPublicationFooter.styled';

export const AssemblyPublicationFooter = (
  props: AssemblyPublicationFooterProps,
) => {
  const { activeParams } = useParamQuery();
  const [loading, setLoading] = useState(false);
  const csvLinkRef = useRef<any>(null);
  const { csvData, fetchExportData, setCsvData } = useExportAllAssemblies();

  const handleExportClick = async () => {
    if (props.disableExport) {
      return;
    }
    setLoading(true);

    try {
      setCsvData([]);
      await fetchExportData();
      setTimeout(() => {
        csvLinkRef.current?.link?.click();
      }, 0);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <FooterContainer>
      <FooterActions>
        <Button
          variant="outlined"
          onClick={handleExportClick}
          startIcon={<SaveAlt />}
          disabled={props.disableExport || loading}>
          {lang.exportAllToCsv}
        </Button>

        {!props.hideDelete && (
          <LoadingButton
            variant="outlined"
            color="error"
            onClick={props.onDelete}
            startIcon={<DeleteOutlinedIcon />}
            disabled={props.disableDelete}
            loading={props.isDeleting}>
            {lang.deleteText}
          </LoadingButton>
        )}
        {!props.hideSave && (
          <Tooltip title={props.disableSave ? props.saveDisabledMessage : ''}>
            <span>
              <LoadingButton
                variant="contained"
                onClick={props.onSave}
                disabled={props.disableSave}
                loading={props.isSaving}>
                {props.saveLabel || lang.save}
              </LoadingButton>
            </span>
          </Tooltip>
        )}
        <CSVLink
          data={csvData}
          headers={ASSEMBLY_PUBLICATION_HEADERS}
          filename={`${
            activeParams?.status?.[0] === PUBLICATION_STATUS.SAVED
              ? 'Save'
              : 'Stage'
          }_Bulk_Replace_${dayjs().format('MM-DD-YYYY')}.csv`}
          target="_blank"
          style={{ textDecoration: 'none' }}
          ref={csvLinkRef}
        />
      </FooterActions>
    </FooterContainer>
  );
};
